// Inject CSS styles for disabled quantity inputs and buttons
(() => {
  // Add styles only once even if script is called multiple times
  if (!document.getElementById('lock-cart-styles')) {
    const style = document.createElement('style');
    style.id = 'lock-cart-styles';
    style.textContent = `
      .quantity__input:disabled {
        background-color: #f2f2f2;
        color: #888;
        cursor: not-allowed;
      }
      .quantity__button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
      .cart__qty-input:disabled,
      [data-quantity-input]:disabled,
      [name="updates[]"]:disabled {
        background-color: #f2f2f2;
        color: #888;
        cursor: not-allowed;
      }
    `;
    document.head.appendChild(style);
  }

  // List of product handles that should have locked quantities
  const lockedProductHandles = ['print-on-demand'];
  
  // Function to lock quantities for specific products
  function lockCartQuantities() {
    // Look for cart items in both drawer cart and cart page
    const cartItems = document.querySelectorAll(
      ".cart-item, .cart__row, .cart-drawer__item, tr[data-cart-item], .cart__table-row"
    );
    
    if (!cartItems.length) return;
    
    cartItems.forEach(item => {
      // Try different selectors for product links based on different cart layouts
      const productLink = item.querySelector(
        'a.cart-item__name, a[href*="/products/"], .cart__product-name, .cart-item__title a, .cart__product-title a'
      );
      
      if (!productLink) return;
      
      const href = productLink.getAttribute('href');
      // Extract handle more robustly
      const match = href.match(/\/products\/([^\/\?#]+)/);
      const handle = match ? match[1] : null;
      
      if (!handle || !lockedProductHandles.includes(handle)) return;
      
      // Lock quantity inputs (try different selectors for various cart layouts)
      const qtyInputs = item.querySelectorAll(
        "input.quantity__input, input.cart__qty-input, [data-quantity-input], input[name='updates[]'], .quantity-selector input"
      );
      
      if (qtyInputs.length) {
        qtyInputs.forEach(input => {
          input.disabled = true;
          input.title = "Quantity can't be modified";
          
          // Find the parent form and add a data attribute to handle cart submissions
          const parentForm = input.closest('form');
          if (parentForm) {
            parentForm.dataset.hasLockedItems = 'true';
          }
        });
      }
      
      // Lock quantity buttons
      const qtyButtons = item.querySelectorAll(
        "button.quantity__button, button[data-quantity-button], .js-qty__adjust, .cart__qty-adjust, .quantity-selector button"
      );
      
      if (qtyButtons.length) {
        qtyButtons.forEach(button => button.disabled = true);
      }
      
      // Mark this item as locked to avoid repeated processing
      item.setAttribute('data-quantity-locked', 'true');
    });
  }
  
  // Function to setup protection against cart form submissions that might change locked quantities
  function protectCartUpdates() {
    // Find all cart forms
    const cartForms = document.querySelectorAll('form[action="/cart"], form[action="/cart/update"], form[action^="/cart"]');
    
    cartForms.forEach(form => {
      // Skip if we've already processed this form
      if (form.hasAttribute('data-lock-handler-added')) return;
      
      form.setAttribute('data-lock-handler-added', 'true');
      
      // Add submit handler to ensure locked items retain their quantities
      form.addEventListener('submit', function(e) {
        if (this.dataset.hasLockedItems !== 'true') return; // No locked items in this form
        
        const lockedInputs = this.querySelectorAll('input[disabled][name="updates[]"]');
        
        // Store original values of locked items
        const lockedValues = Array.from(lockedInputs).map(input => {
          return {
            name: input.name,
            value: input.value,
            key: input.getAttribute('data-key') || input.getAttribute('data-cart-item-key') || ''
          };
        });
        
        // If we have locked items, ensure their values are preserved on form submission
        if (lockedValues.length) {
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              // After form submission, reapply locks
              setTimeout(lockCartQuantities, 500);
            })
            .catch(error => console.error('Error preserving locked quantities:', error));
        }
      });
    });
  }
  
  // Initial lock when the page loads
  function initialize() {
    lockCartQuantities();
    protectCartUpdates();
    setupCartObservers();
  }
  
  // Set up observers to detect cart changes (item removal, quantity updates, etc.)
  function setupCartObservers() {
    // Try to find all possible cart containers
    const cartContainers = document.querySelectorAll(
      'form[action="/cart"], .cart-drawer, .cart, #CartDrawer, #cart-form, [data-section-type="cart-template"]'
    );
    
    if (!cartContainers.length) return;
    
    cartContainers.forEach(container => {
      // Skip if we've already added an observer
      if (container.hasAttribute('data-cart-observer-added')) return;
      
      container.setAttribute('data-cart-observer-added', 'true');
      
      // Create observer for this container
      const observer = new MutationObserver((mutations) => {
        const needsUpdate = mutations.some(mutation => {
          // New nodes added or nodes removed
          if (mutation.addedNodes.length || mutation.removedNodes.length) return true;
          
          // Changes to attributes of cart items or their children
          if (mutation.type === 'attributes') {
            const target = mutation.target;
            const isCartItem = target.classList && (
              target.classList.contains('cart-item') || 
              target.classList.contains('cart__row') ||
              target.hasAttribute('data-cart-item')
            );
            const isInsideCartItem = target.closest('.cart-item, .cart__row, [data-cart-item]');
            
            if (isCartItem || isInsideCartItem) return true;
          }
          
          return false;
        });
        
        if (needsUpdate) {
          // Small delay to ensure DOM is fully updated
          setTimeout(() => {
            lockCartQuantities();
            protectCartUpdates();
          }, 50);
        }
      });
      
      // Observe this container with appropriate options
      observer.observe(container, { 
        childList: true,      // Watch for added/removed cart items 
        subtree: true,        // Watch the entire subtree
        attributes: true      // Watch for attribute changes
      });
    });
    
    // Listen for Shopify events that might update the cart
    const shopifyEvents = ['cart:refresh', 'cart:updated', 'cart_update', 'ajaxCart.afterCartLoad', 'theme:cart:updated'];
    shopifyEvents.forEach(eventName => {
      document.addEventListener(eventName, () => {
        setTimeout(lockCartQuantities, 300);
      });
    });
    
    // Find and handle remove buttons
    const removeButtons = document.querySelectorAll(
      '.cart-remove-button, .cart-item__remove-button, [data-cart-remove], .cart__remove a, .cart__remove-btn, .js-remove-from-cart'
    );
    
    if (removeButtons.length) {
      removeButtons.forEach(button => {
        if (button.hasAttribute('data-lock-listener-added')) return;
        
        button.setAttribute('data-lock-listener-added', 'true');
        
        button.addEventListener('click', () => {
          setTimeout(() => {
            lockCartQuantities();
            protectCartUpdates();
          }, 500);
        });
      });
    }
    
    // Wait for jQuery and attach ajaxComplete handler with retries every 500ms
    function waitForjQueryAndBind(retries = 10) {
      if (window.jQuery) {
        jQuery(document).ajaxComplete(function(event, xhr, settings) {
          if (settings.url && (
            settings.url.includes('/cart/add') ||
            settings.url.includes('/cart/update') ||
            settings.url.includes('/cart/change') ||
            settings.url.includes('/cart.js'))) {
              setTimeout(() => {
                lockCartQuantities();
                protectCartUpdates();
              }, 300);
          }
        });
      } else if (retries > 0) {
        setTimeout(() => waitForjQueryAndBind(retries - 1), 500);
      } else {
        console.warn('jQuery not loaded, ajaxComplete handler not attached.');
      }
    }
    
    waitForjQueryAndBind();
  }
  
  // Execute based on document readiness
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  // Also run on page load to catch any lazy-loaded elements
  window.addEventListener('load', () => {
    setTimeout(initialize, 500);
  });
  
  // Some themes update cart with pushState or AJAX, so check on URL changes
  let lastUrl = location.href; 
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      if (url.includes('/cart')) {
        setTimeout(initialize, 500);
      }
    }
  }).observe(document, {subtree: true, childList: true});
})();
